import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {FlyReserveWithSearch} from '../containers'
function FlyReserveWithSearchPage() {
    console.log('sv****FlyReserveWithSearchPage')
    let { id,spaceKey } = useParams();console.log('sv****FlyReserveWithSearchPage',id,spaceKey )

    let svparams = { 'id': id, 'spaceKey':spaceKey}
    return (
        <FlyReserveWithSearch svparams= {svparams} />
       
    );
}
export default FlyReserveWithSearchPage